import React from 'react';
import '../styles/Experience.css';

const ExperienceCard = ({ year, role, company, description }) => {
  return (
   <div className="experience-card bg-white p-4 rounded shadow flex flex-col gap-2 h-full">
    <div className="experience-card-date text-gray-500 font-semibold">{year}</div>
    
    <div className="experience-card-content flex flex-col gap-1">
      <h3 className="text-lg font-bold">{role}</h3>
      <h4 className="text-md text-gray-600">{company}</h4>
      <p className="text-gray-700">{description}</p>
    </div>
  </div>

  );
};

export default ExperienceCard;

